import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as adminActions from '../actions/admin-actions';

class AdminInvitesPage extends Component {
  constructor(props) {
    super(props);
    this.renderList = this.renderList.bind(this);
    this.renderInvite = this.renderInvite.bind(this);
    this.approveInvite = this.approveInvite.bind(this);
    this.cancelInvite = this.cancelInvite.bind(this);
  }

  componentDidMount() {
    this.props.actions.requestPendingInvites();
  }

  approveInvite(invite) {
    console.info('Approving invite:', invite.id);
    this.props.actions.requestApproveInvite(invite);
  }

  cancelInvite(invite) {
    console.info('Cancelling invite:', invite.id);
    this.props.actions.requestCancelInvite(invite);
  }

  renderInvite(invite) {
    return <li key={invite.id}>{invite.email} (invited by {invite.user.name}) <button onClick={() => this.approveInvite(invite)}>Approve</button>&nbsp;<button onClick={() => this.cancelInvite(invite)}>Reject</button></li>;
  }

  renderList() {
    let fetchingInvites = this.props.admin.fetchingPendingInvites;
    let invites = this.props.admin.pendingInvites;
    if (fetchingInvites) {
      return <p>Fetching invite list...</p>
    }

    if (!invites.length) {
      return <p>No pending invites!</p>
    }

    return <ul className="AdminInviteList">
      {invites.map(this.renderInvite)}
    </ul>;
  }

  render() {
    return (
      <div className="AdminInvitesPage">
        <h1>Unapproved invites</h1>
        {this.renderList()}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(adminActions, dispatch)
  };
};

function mapStateToProps(state) {
  return {
    admin: state.admin
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminInvitesPage);



// WEBPACK FOOTER //
// ./src/containers/AdminInvitesPage.js